import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { RTL } from "../../../cache/CacheRtl";
import { t } from "./coachTokens";
import { getCheckInById } from "../../../services/CheckInService";
import {
  BodyWeightSection,
  MeasurementsSection,
  PhotosSection,
  FormSection,
} from "../../check-ins/CheckInDetailSections";

const TYPE_LABELS = {
  BODY_WEIGHT: "משקל גוף",
  BODY_MEASUREMENT: "מדידות גוף",
  PROGRESS_PHOTO: "תמונות התקדמות",
  FORM: "טופס",
};

const renderSection = (item, traineeId) => {
  switch (item.type) {
    case "BODY_WEIGHT":
      return <BodyWeightSection item={item} />;
    case "BODY_MEASUREMENT":
      return <MeasurementsSection traineeId={traineeId} item={item} />;
    case "PROGRESS_PHOTO":
      return <PhotosSection item={item} />;
    case "FORM":
      return <FormSection item={item} />;
    default:
      return (
        <Box sx={{ padding: "20px", color: t.t3, textAlign: "center" }}>
          סוג פריט לא מוכר
        </Box>
      );
  }
};

const CheckInItemDialog = ({ open, onClose, checkInId, traineeId, itemType }) => {
  const [loading, setLoading] = useState(false);
  const [checkIn, setCheckIn] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !checkInId) return;
    setLoading(true);
    setError(null);
    setCheckIn(null);
    getCheckInById(checkInId)
      .then((res) => setCheckIn(res.data))
      .catch((e) => setError(e?.response?.data?.errorMessage || "שגיאה בטעינת הצ׳ק-אין"))
      .finally(() => setLoading(false));
  }, [open, checkInId]);

  const item = checkIn?.items?.find((i) => i.type === itemType);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "16px" } }}>
      <RTL>
        <Box dir="rtl">
          <Box sx={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "14px 18px", borderBottom: `1px solid ${t.border}`,
          }}>
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: t.text }}>
              {TYPE_LABELS[itemType] || "פריט צ׳ק-אין"}
            </Typography>
            <IconButton onClick={onClose} size="small" sx={{ color: t.t2 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "18px", minHeight: 120 }}>
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center", padding: "40px" }}>
                <CircularProgress size={28} />
              </Box>
            )}
            {!loading && error && (
              <Box sx={{ padding: "20px", color: t.red, textAlign: "center" }}>{error}</Box>
            )}
            {!loading && !error && checkIn && !item && (
              <Box sx={{ padding: "20px", color: t.t3, textAlign: "center" }}>
                הפריט לא נמצא בצ׳ק-אין הזה
              </Box>
            )}
            {!loading && !error && item && renderSection(item, traineeId)}
          </DialogContent>
        </Box>
      </RTL>
    </Dialog>
  );
};

export default CheckInItemDialog;
